// extracted by mini-css-extract-plugin
export default {"accordionHeader":"_1DstEfiLUBHQjS1R0Sha71","accordionTitle":"_3ZYEWZDcElG10APyxleP3q","accordionToggle":"_4ZW3orDEEGNo0y7Q6TI53N"};